export enum IUserRole {
    STUDIO_OWNER = 'studio_owner',
    STUDIO_MASTER = 'studio_master',
    STUDIO_MASTER_RENT = 'studio_master_rent',
    STUDIO_ADMIN = 'studio_admin',
    MASTER = 'master',
    CLIENT = 'client',
}

export default IUserRole;
